<template>
  <div
    class="mt-2 md:grid"
    :style="gridRows"
    :class="[gridClass, center ? 'justify-center' : '']"
  >
    <PartnersCard v-editable="partner" v-for="(partner, i) in partners" :key="partner._uid"
                  class="h-[144px] md:w-full w-[244px] mx-auto md:mx-0 p-8 flex justify-center items-center border-b-2 border-r-2 border-gray-50"
    :class="[...this.getCornerClasses(i, partners.length, partnersPerRow)]"
    >
      <a :href="partner.href" target="_blank">
        <img class="object-contain max-w-[184px] md:max-w-full" :src="partner.src.filename" :alt="partner.name"/>
      </a>
    </PartnersCard>

    <slot/>

  </div>
</template>

<script>

import PartnersCard from './PartnersCard.vue';
import {useWindowSize} from "@vueuse/core";
const {width} = useWindowSize()
export default {

  setup() {
    const getCornerClasses =(index, totalItems, cols) => {
      const classes = []

      if (width.value > 800) {
        const row = Math.floor(index / cols)
        const col = index % cols

        const totalRows = Math.ceil(totalItems / cols)

        const isFirstRow = row === 0
        const isLastRow = row === totalRows - 1
        const isFirstCol = col === 0
        const isLastCol = (col === cols - 1) || (index === totalItems - 1 && isLastRow)
        const isSecondToLastRow = (row === totalRows - 2)
        const lastRowIsNotFull = totalRows * cols !== totalItems

        if (isFirstRow && isFirstCol) classes.push('rounded-tl-[20px]')
        if (isFirstRow && isLastCol) classes.push('rounded-tr-[20px]')
        if (isLastRow && isFirstCol) classes.push('rounded-bl-[20px]')
        if (isLastRow && isLastCol) classes.push('rounded-br-[20px]')
        if (isFirstCol && isLastRow) classes.push('rounded-bl-[20px]')
        if (isLastCol && isSecondToLastRow && lastRowIsNotFull) classes.push('rounded-br-[20px]')
      } else {
        if (index === 0) {
          classes.push('rounded-t-[20px]')
        } else if (index === (totalItems-1)) {
          classes.push('rounded-b-[20px]')
        }
      }

      return classes
    }
    return {
      getCornerClasses,
    }
  },

  components: {
    PartnersCard
  },

  props: {
    partners: {
      type: Array,
      default: () => []
    },

    center: {
      type: Boolean,
      default: false
    },

    partnersPerRow: {
      type: Number,
      default: 4
    }
  },

  computed: {
    gridRows() {

      let rowsCount = this.partners.length / this.partnersPerRow;


      return {
        gridTemplateRows: `repeat(${rowsCount}, minmax(0, 1fr))'`
      }
    },

    gridClass() {

      return this.center ? 'grid-cols-1' : `grid-cols-${this.partnersPerRow}`;
    },
  },
};
</script>

<style>
</style>
